window.SkillsOverview = Block.extend({
    initialize: function(app, data, $dom, xml) {
        this.skillManager = app.getComponent("SkillsManager");
        Block.prototype.initialize.call(this, app, data, $dom, xml);
    },

    render: function() {
        var content = this.getContent(this.data);
        this.$el.html(content);
        this.setupVariables();
        this.addButtonListener();
        this.animateCategories();
    },
    setupVariables: function() {
        this.$title = this.$el.find(".title");
        this.$categories = this.$el.find(".category");
        this.$confirmButton = this.$el.find(".confirm-button");
    },

    animateCategories: function() {
		var items = this.$el.find( ".title, .category, .confirm-button")
		
		TweenMax.set(items, {
            y: 30,
            opacity: 0,
		});
		
		TweenMax.staggerTo(items, 0.7, {
            y: 0,
            opacity: 1,
            ease: Power4.easeOut,
		}, 0.1);
		
    },

    addButtonListener: function() {
        this.confirmButton = new Button({
            el: this.$confirmButton
        });
        this.listenTo(this.confirmButton, "onClick", this.handleConfirmButton);

        _.each(this.data.categories, function(category, i) {
            var $catergory = $(this.$categories[i]);
            _.each(category.levels, function(level, j) {
                var $level = $catergory.find(".level-" + j);
                var levelButton = new Button({
                    el: $level,
                    buttonClass: "",
                    isDisabled: level.isDisabled
                });
                this.listenTo(levelButton, "onClick", this.handleLevelButton);
            }, this);
        }, this);
    },

    handleLevelButton: function(e) {
        var $button = $(e.currentTarget);
        if (!$button.hasClass("disabled")) {
            this.showSkills($button);
        }
    },

    showSkills: function($button) {
        var self = this;
        if (this.bootbox === undefined) {
            this.bootbox = new AccessibleBootbox({
                title: $button.attr("categoryTitle") + ": " + $button.find(".level-title").text(),
                message: self.getSkills($button),
                className: "skills-popup",
                animate: true,
                buttons: {
                    okay: {
                        label: LanguageManager.getString("close"),
                        className: "btn-primary",
                        callback: function() {
                            if (self.bootbox !== undefined) {
                                self.bootbox.destroy();
                            }
                            self.bootbox = undefined;
                        }
                    }

                }
            });

            this.bootbox.popIn();
        }
    },

    getSkills: function($button) {
        var category = $button.attr("category");
        var rating = Number($button.attr("rating"));

        var $ul = $("<ul></ul>");
        this.skills = this.skillManager.getSkills({
            category: category,
            rating: rating
        });
        _.each(this.skills, function(skill, i) {
            var $li = $("<li></li>");

            var $title = $("<div class='title'>" + skill.getTitle() + "</div>");
            $li.append($title);

            var $buttonHolder = $("<div class='button-holder'></div>");
            var $pinButton = $("<div class='pin' title='" + skill.getTitle() + "' id='" + i + "'></div>");
            var pinButton = new Button({
                el: $pinButton,
                buttonClass: ''
            });
            this.listenTo(pinButton, "onClick", this.handlePinButton);

            if (skill.isPinned() === true) {
                $pinButton.append(LanguageManager.getString("unpin"));
            } else {
                $pinButton.append(LanguageManager.getString("pin"));
            }
            $buttonHolder.append($pinButton);
            $li.append($buttonHolder);

            $ul.append($li);
        }, this);
        return $ul;
    },

    handlePinButton: function(e) {
        var $pinButton = $(e.currentTarget);
        var id = Number($pinButton.attr("id"));
        var skill = this.skills[id];

        this.skillManager.addSkill({
            pageId: skill.getPageId(),
            category: skill.getCategory(),
            rating: skill.getRating(),
            title: skill.getTitle(),
            notes: skill.getNotes(),
            isPinned: (!skill.isPinned())
        });

        if (skill.isPinned() === true) {
            $pinButton.text(LanguageManager.getString("unpin"));
        } else {
            $pinButton.text(LanguageManager.getString("pin"));
        }
    },

    handleConfirmButton: function() {
        this.complete();
        this.app.router.next();
    },

    getData: function($xml, language) {
        var data = {};

        var $items = $xml.find("mainText > index");
        data.title = $($items[0]).find("title").text();
        data.instruction = $($items[0]).find("text").text();
        data.confirmLabel = LanguageManager.getString("my_action_plan");
        data.categories = [];
        for (var i = 0; i < 4; i++) {
            var category = {};
            category.id = i;
            category.type = SkillsOverview.CATEGORIES[i];
            category.icon = category.type + "-icon";
            category.title = LanguageManager.getString(category.type);
            category.levels = [];
            for (j = 0; j < 4; j++) {
                var level = {};
                level.id = j;
                level.type = SkillsOverview.LEVELS[j];
                level.rating = (3 - j);
                level.category = category.type;
                level.categoryTitle = category.title;
                level.title = LanguageManager.getString(level.type);
                level.skills = this.skillManager.getSkills({
                    category: level.category,
                    rating: (3 - j)
                });
                level.value = level.skills.length;
                level.isDisabled = (level.value <= 0) ? true : false;
                category.levels.push(level);

                Logger.info(level.category, ":", level.type, ":", level.value, ":", level.isDisabled);
            }
            data.categories.push(category);
        }
        return data;
    },

    getContent: function(data) {
        return Handlebars.templates["skillsoverview/skillsoverview"](data);
    },

}, {
    CATEGORIES: [
        "data",
        "people",
        "ideas",
        "things"
    ],
    LEVELS: [
        "very_competent",
        "competent",
        "adequate",
        "undeveloped"
    ]
});
